export const ingredientErrorType = {
  PRICE_UNAVAILABLE: "PRICE_UNAVAILABLE",
  REPLACED: "REPLACED",
  UNIT_MISMATCH: "UNIT_MISMATCH",
  INVALID_SUPC: "INVALID_SUPC",
  NOT_FOUND: "NOT_FOUND",
};